export const getOverflowPixels = (child, container) => {
  if (!child || !container) return false
  return (
    child.getBoundingClientRect().right -
    container.getBoundingClientRect().right
  )
}
